import { useState, useEffect, useRef } from "react";
import { useParams, Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import axios from "axios";
import Loader from "react-js-loader";
import Navbar from "../../Component/navbar/Navbar";
import Footer from "../../Component/Footer/Footer";
import { Helmet } from "react-helmet";
import "../Admin/AdminSetting/AdminSetting.scss";
import "../Admin/AdminBlogs/blog.css";
import { blogsFAQ } from "./constant";

const SingleUserBlog = () => {
  const id = useParams();
  const [singleFAQ, setSingleFAQ] = useState({});
  const [blog, setBlog] = useState([]);
  const [loading, setLoading] = useState(true);
  const ref = useRef();
  const fetchBlogs = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/blog/${id.id}`);
      setBlog(res.data.blog);
      const singleFAQs = blogsFAQ.find((item) => item.blogTitle === res.data.blog.title);

      setSingleFAQ(singleFAQs);
      setLoading(false);
      ref.current.scrollIntoView({ behavior: "smooth" });
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, [id]);

  return (
    <>
      <Navbar />
      <div className="adminSettingContainer">
        <Helmet>
          <meta name="title" content={blog.metaTitle} />
          <title>{blog.metaTitle}</title>
          <meta name="title" content={blog.metaTitle} />
          <meta name="description" content={blog.metaDescription} />
          <meta name="keywords" content={blog.keywords} />
          //canonical added
          <link rel="canonical" href={`https://qrcodebrew.com/${blog.shorturl ? blog?.shorturl : blog?._id}`} />
          {blog?.schemas && <script type="application/ld+json">{blog?.schemas}</script>}
        </Helmet>

        <div className="adminSettingWrapper">
          <span className="openIconBlog" style={{ background: "#58a697" }}>
            <Link to={"/blogs"}>
              <i className="fa fa-chevron-left" style={{ color: "#ffffff" }} />
            </Link>
          </span>
          {!loading ? (
            <div className="container" ref={ref}>
              <div className="top d-flex justify-content-between mb-4">
                <div className="heading">View Blog</div>
                <div></div>
              </div>
              <div className="bottom">
                <div className="blog-txt text-center">
                  <h5>{blog?.name}</h5>
                  <h1>{blog?.title}</h1>
                  <h5>{blog?.createdAt?.slice(0, 10)}</h5>
                </div>

                <img loading="lazy" className="blog-img" src={blog?.cover} alt={blog.imageAlt} />

                {/* <div className="blog-txt"> */}
                <p
                  className="blogContent"
                  dangerouslySetInnerHTML={{
                    __html: blog?.content,
                  }}
                />
                {/* </div> */}
              </div>
            </div>
          ) : (
            <Loader type="spinner-default" bgColor={"#db9d48"} color={"#db9d48"} size={100} />
          )}
        </div>
        <ToastContainer />
      </div>
      <Footer color={true} />
    </>
  );
};
export default SingleUserBlog;
